import { ensureOk } from "@/api/apiError";
import { useMutation } from "@tanstack/react-query";
import { httpClient } from "@/api/httpClient";
import type { UploadedFile } from "@/types";

async function uploadFile(file: File): Promise<UploadedFile> {
  const formData = new FormData();
  formData.append("file", file);

  const response = await httpClient("/files", {
    method: "POST",
    body: formData,
  });
  await ensureOk(response);
  return response.json() as Promise<UploadedFile>;
}

/** US-05: uploads a chat attachment ahead of sending a message; returns its metadata
 * (id, fileName, mimeType, sizeBytes, uploadedAt) so the id can be attached to a message. */
export function useUploadFile() {
  return useMutation({ mutationFn: uploadFile });
}
